import React from 'react';
import { CHECKOUT_URL, PURCHASE_ANCHOR } from '../data/content';
interface CTAButtonProps {
  label: string;
  sub?: string;
  target?: 'purchase' | 'checkout';
  className?: string;
}
export function CTAButton({
  label,
  sub,
  target = 'purchase',
  className = ''
}: CTAButtonProps) {
  return <a href={target === 'checkout' ? CHECKOUT_URL : PURCHASE_ANCHOR} className={`block w-full rounded-md bg-gold px-3 py-3 text-center font-heading text-[0.84rem] font-extrabold uppercase leading-tight tracking-wide text-navy shadow-[0_5px_0_0_#B98A22] transition-[background-color,transform,box-shadow] duration-150 ease-out hover:bg-gold-light active:translate-y-[3px] active:shadow-[0_2px_0_0_#B98A22] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40 sm:text-lg ${className}`} data-id="element-29" data-mp="2fz1z6gy9kmsv">
      {label}
      {sub ? <span className="mt-0.5 block font-body text-[0.66rem] font-semibold normal-case tracking-normal text-navy/80 sm:text-xs" data-id="element-30" data-mp="3cq424tay45w4">
          {sub}
        </span> : null}
    </a>;
}